import React from 'react';

export default function SiteBloqueado() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, rgb(18, 52, 116) 0%, rgb(29, 59, 125) 100%)',
      padding: '20px',
      fontFamily: 'Roboto, sans-serif'
    }}>
      <div style={{
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 4px 20px rgba(18, 52, 116, 0.3)',
        padding: '50px 40px',
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center',
        border: '1px solid rgb(18, 52, 116)'
      }}>
        {/* Logo do projeto */}
        <div style={{ marginBottom: '30px' }}>
          <img
            src="/imagens/logo-dark.png"
            alt="Logo Clube Pro Pintor"
            style={{
              maxWidth: '200px',
              height: 'auto'
            }}
          />
        </div>
        
        <div style={{
          background: '#f8f9fa',
          borderRadius: '4px',
          padding: '20px',
          border: '1px solid rgb(18, 52, 116)'
        }}>
          <p style={{
            fontSize: '16px',
            color: 'rgb(18, 52, 116)',
            margin: '0',
            fontWeight: '500',
            lineHeight: '1.6'
          }}>
            Estamos realizando uma reformulação no site. 
            Agradecemos a sua compreensão e voltamos logo!
          </p>
        </div>
        
      </div>
    </div>
  );
}
